/**
 * Build-time environment the dashboard reads, in one place. Vite inlines
 * `import.meta.env.VITE_*` at bundle time, so every reader of a flag is a
 * separate literal in the bundle — two readers of the same variable can
 * only agree by convention. Keep the parsing here so a flag has one
 * spelling and one truthiness rule.
 *
 * (`lib/axios.ts` reads `VITE_API_BASE_URL`, `lib/wsBaseUrl.ts` reads
 * `VITE_WS_BASE_URL` and `lib/sentry.ts` reads the Sentry DSN/release next
 * to the code that consumes them; feature-policy flags belong here.)
 */

/**
 * Self-serve sign-up is disabled until the subscription/billing flow ships
 * (see docs/dev-phases/phase-35-subscription-billing.md). The env flag lets
 * dev/staging re-enable the open `/register` path — both the route gate and
 * the login page's "Create an account" link read this one value.
 */
export const SIGNUP_ENABLED = import.meta.env.VITE_ENABLE_SELF_SIGNUP === 'true';
